import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-pie', 'ChartPie', [["path",{"d":"M12 21a9 9 0 0 0 9-9h-9V3a9 9 0 0 0 0 18","key":"svg-0"}]]);